import { TIME_TYPE, VOUCHER_TYPE } from '@src/constants/voucher';
import moment from 'moment';

const { PACKAGE_LEVEL, PACKAGE_CODE } = require('@src/constants/package');

const checkTodayDisplay = () => {
  const today = moment().format('DD/MM/YYYY');
  const prevDisplayInfo = JSON.parse(
    localStorage.getItem('AUTO_RENEWAL_BANNER'),
  );

  const todayDisplay =
    (!prevDisplayInfo || prevDisplayInfo?.date !== today) &&
    !prevDisplayInfo?.notShowAgain;
  return todayDisplay;
};

const checkShowAutoRenewalPayment = ({
  packageCode = '',
  alwayShow = true,
}) => {
  if (!packageCode) return false;

  const isFreePackage =
    packageCode.includes(PACKAGE_LEVEL.TRIAL) ||
    packageCode.includes(PACKAGE_LEVEL.BASIC) ||
    packageCode.includes(PACKAGE_CODE.STUDIO_FREE);

  if (alwayShow) return !isFreePackage;
  return !isFreePackage && checkTodayDisplay();
};

const getOrderPackageInfoWhenApplyVoucher = ({ packageInfo, voucher }) => {
  const { type, value, timeType } = voucher || {};
  if (type === VOUCHER_TYPE.CHARACTER) {
    const customMaxCharacters = packageInfo?.maxCharacters * value;
    const customCredits = packageInfo?.maxCredits
      ? packageInfo?.maxCredits * value
      : 0;
    const customCreditsPerCycle = packageInfo?.cycle?.creditsPerCycle * value;
    return {
      ...packageInfo,
      maxCharacters: customMaxCharacters,
      maxCredits: customCredits,
      cycle: { ...packageInfo?.cycle, creditsPerCycle: customCreditsPerCycle },
    };
  }
  if (type === VOUCHER_TYPE.TIME && timeType === TIME_TYPE.MONTH) {
    const totalCycles = packageInfo?.cycle?.totalCycles + value;
    return {
      ...packageInfo,
      cycle: { ...packageInfo?.cycle, totalCycles },
    };
  }

  // TODO: Handle other voucher types
  return packageInfo;
};

export { checkShowAutoRenewalPayment, getOrderPackageInfoWhenApplyVoucher };
